import { useContext, useEffect, useState } from "react";
import { ParagraphText, UBButton, UBOTPInput } from "../../../../Libraries";
import { CreatePinLock } from "../../../../assets/icons/icon";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@material-ui/core";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { CircularProgress } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

import { isValidPin } from "../../../../utils";
import { HeaderRupin } from "../../../common";
import { useNavigate } from "react-router-dom";
import { handleApi } from "../../../../apis";
import { SET_PIN_POST } from "../../../../apis/configuration";
import Cookies from "js-cookie";
import styles from "./styles.module.css";
import { Sync } from "../../../../SyncService";
import { useAuthContext } from "../../../../context/AuthContext";

const CreatePin = ({
  handleCancel,
  handleSetPINSuccess,
  oldPIN,
  isHeader = true,
  isOnboarding = true,
  phone,
  userId
}) => {
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const { user, setUser } = useAuthContext();

  const [PINObj, setPINObj] = useState({
    pin: "",
    reconfirmPin: "",
  });
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const [isCreatePINError, setIsCreatePINError] = useState(false);
  const navigate = useNavigate();
  const onChangeQuery = (val, key) => {
    if (key === "pin") {
      if (PINObj.pin.length === 0 && val.length >= 1) {
        triggerLogEvent(analytics, "setup_pin_enter");
      }
    }
    if (key === "reconfirmPin") {
      if (PINObj.reconfirmPin.length === 0 && val.length >= 1) {
        triggerLogEvent(analytics, "setup_pin_enter_confirm");
      }
    }
    setPINObj((pin) => ({ ...pin, [key]: val }));
  };

  useEffect(() => {
    if (PINObj.pin.length === 4 && !isValidPin(PINObj.pin)) {
      setError(I18n.weak_pin_choose_something_else);
      setIsCreatePINError(true);
    } else if (PINObj.pin.length === 4 && PINObj.reconfirmPin.length === 4) {
      setError(
        PINObj.pin !== PINObj.reconfirmPin ? I18n.pin_did_not_match : "",
      );
      setIsCreatePINError(false);
    } else {
      setError("");
      setIsCreatePINError(false);
    }
  }, [PINObj]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const payload = {
        old_pin: oldPIN || undefined,
        new_pin: PINObj.pin,
      };
      const response = await handleApi(SET_PIN_POST, payload, null, navigate, {
        "Web-Token": Cookies.get("deviceId"),
      });
      if (userId) {
        const updatedUser = await user.updatePhone(phone);
        setUser(updatedUser);
        Cookies.remove("tempUserId");
        await Sync(phone, navigate);
      }
      if (response?.message && response?.success) {
        showSnackbar({
          message: response?.message,
          severity: "success",
          icon: "",
        });
      }
      triggerLogEvent(analytics, "login_pin_created");
      triggerLogEvent(analytics, "setting_pin_save", {});
      handleSetPINSuccess({ ...response, PINObj });
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const isDisabled =
    !(PINObj.pin.length === 4 && PINObj.reconfirmPin.length === 4) ||
    !!error ||
    loader;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (isDisabled) return;
        handleSubmit(e);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDisabled]);
  const openWhatsApp = () => {
    triggerLogEvent(analytics, "create_pin_help");
    window.open(
      "https://api.whatsapp.com/send/?phone=%2B923420191000&text&type=phone_number&app_absent=0",
      "_blank",
    );
  };

  return (
    <div className={`${styles.CreatePinContainer} ${isOnboarding ? "onBoardingScreenWrapper" : ""}`}>
      {isHeader && <HeaderRupin handleHelpClick={openWhatsApp} />}
      <Box className={styles.CreatePinInnerBox}>
        <Box className={styles.CreatePinForm}>
          <Box className={styles.createPinHeader}>
            <ParagraphText
              className={`fontSize24 fontWeight500 newFontColor`}
              id="create_your_pin"
            >
              {I18n.create_your_new_pin}
            </ParagraphText>

            <ParagraphText
              className={`fontSize14 fontWeight400 newLightColor`}
              id="create_your_pin_desc"
            >
              {I18n.your_accounts_first_line_of_defence_make_sure_its_unique}
            </ParagraphText>
          </Box>
          <UBOTPInput
            id="create_your_pin"
            label={I18n.create_your_new_pin}
            onChangeQuery={(val) => onChangeQuery(val, "pin")}
            value={PINObj.pin}
            invalid={isCreatePINError && !!error}
            helperText={isCreatePINError && error}
            shouldAutoFocus
            isInputSecure={true}
          />

          <UBOTPInput
            id="confirm_your_pin"
            label={I18n.confirm_your_new_pin}
            onChangeQuery={(val) => onChangeQuery(val, "reconfirmPin")}
            value={PINObj.reconfirmPin}
            invalid={!isCreatePINError && !!error}
            helperText={!isCreatePINError && error}
            disabled={PINObj.pin.length !== 4 || isCreatePINError}
            isInputSecure={true}
          />

          <Box className={styles.CreatePinCTA}>
            <UBButton
              id="create_pin_cancel_btn"
              title={I18n.cancel}
              onClick={handleCancel}
              className={`ubSecondaryButton textUppercase`}
            />
            <UBButton
              id="create_pin_save_btn"
              title={I18n.confirm}
              loading={loader}
              disabled={isDisabled}
              onClick={handleSubmit}
              className={`${styles.savePINBtn} ubPrimaryButton fontSize14 fontWeight400 textUppercase`}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default CreatePin;
